module.exports = __webpack_public_path__ + "img/24555742000141.2af8c738.png";